/* eslint-disable  @typescript-eslint/no-explicit-any */
import type {PipeMiddlewareElement} from '../../middleware-pipe';
import type {MiddlewarePipeDetails} from '../../models/middleware-pipe-details.model';
import {makeLogger} from '../../../../logger/logger';
import type { PipeMiddlewareNext } from '../../middleware-pipe';

const { debug } = makeLogger({pathToCurrentFile:'utils/middleware/middleware-apply-facet-options.ts'});

export const ApplyFacetOptionsMiddleware: PipeMiddlewareElement<MiddlewarePipeDetails,any> = async (
  details: MiddlewarePipeDetails,
  next: PipeMiddlewareNext<any>, //eslint-disable-line
  middlewareDepth: number,
  middlewareArray: Array<PipeMiddlewareElement<MiddlewarePipeDetails, any>>
) => {

    const facets = details.context?.facets ?? [];

    const facetsOptions = facets.length == 0 ? {} : {
      'facetsOptions':{
        fetch: true,
        fetchList: facets,
      }
    };




    const newDetails = {
      ...details,
      middlewareRequest:{
        ...details.middlewareRequest,
        requestBody: {
          ...details.middlewareRequest.requestBody,
          ...facetsOptions
        }
      }
    };


    debug('addFaqFacetOptions new details', newDetails);
    const response = await next(newDetails);
    debug('addFaqFacetOptions response', response);

    return new Promise(r => {
        r(response); //return the response;
    });

};
